import { UserAnalysisService } from "@/api/service-proxies";

export const userAnalysisService = new UserAnalysisService();
